import { render, staticRenderFns } from "./VideoCallKHDN.vue?vue&type=template&id=a384f0f6&scoped=true"
import script from "./VideoCallKHDN.vue?vue&type=script&lang=js"
export * from "./VideoCallKHDN.vue?vue&type=script&lang=js"
import style0 from "./VideoCallKHDN.vue?vue&type=style&index=0&id=a384f0f6&prod&lang=scss"
import style1 from "./VideoCallKHDN.vue?vue&type=style&index=1&id=a384f0f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a384f0f6",
  null
  
)

export default component.exports